<template>
  <div>
    <v-card class="mb-4" outlined>
      <v-toolbar
          color="#488ba6"
          dark
          outlined
      >
        <v-toolbar-title>{{ state.member.meeting.meetingInfo.name }}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-form>
        <v-radio-group v-model="state.member.meeting.registrationSelected" column>
          <v-simple-table>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left" style="max-width: 100px">Registration Type</th>
                <th class="text-left">Fee</th>
                <th class="text-left">Choice</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(reg, index) in state.member.meeting.registrationProducts" :key="'reg-'+index"
                  class="ma-4">
                <td class="text-left" style="max-width: 100px">
                  {{ reg.name }}<br>
                  <small><em>{{ reg.desc }}</em></small>
                </td>
                <td class="text-left">{{
                    new Intl.NumberFormat('en-US', {
                      style: 'currency',
                      currency:
                          'USD'
                    }).format(reg.price)
                  }}
                </td>

                <td class="text-left" style="max-width: 50px">
                  <v-radio :value="reg"></v-radio>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-radio-group>
      </v-form>

    </v-card>
    <v-card outlined v-if="state.member.meeting.registrationSelected">
      <v-toolbar
          color="#488ba6"
          dark
          flat
      >
        <v-toolbar-title>Special Event Tickets</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <ExtraProducts />

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#488ba6" @click="setupForm" style="color:white">Continue</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import ExtraProducts from "@/components/ExtraProducts"

export default {
  name: "MeetingProducts",
  data: function () {
    return {
      sent: false,
      dialog: false,
    }
  },
  computed: {
    ...mapGetters({
      state: 'getState',
    }),

  },
  methods: {
    setupForm: function () {
      this.sent = true;
      this.$store.commit('setupForm')
      this.sent = false;
    },
  },
  components: {
    ExtraProducts
  }
}
</script>

<style scoped>

</style>